export const TestBadge = ({ show, testid }) =>
  show ? <span className="ml-1.5 rounded bg-amber-100 px-1.5 py-0.5 align-middle font-sans text-[10px] font-semibold text-amber-800" data-testid={testid}>TEST</span> : null;
